import { useState } from 'react';
import { ErroApi } from '../lib/api';
import { criarEvento } from '../lib/agenda';
import { doCampoDataHora } from '../lib/quadro';
import { Alerta, Botao, Cartao } from './Interface';

export default function NovoEvento({
  diaSugerido,
  aoFechar,
  aoCriar,
}: {
  diaSugerido: string;
  aoFechar: () => void;
  aoCriar: () => Promise<void>;
}) {
  const [titulo, setTitulo] = useState('');
  const [tipo, setTipo] = useState('culto');
  const [local, setLocal] = useState('');
  const [quando, setQuando] = useState(`${diaSugerido}T19:00`);
  const [publico, setPublico] = useState(true);
  const [descricao, setDescricao] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [salvando, setSalvando] = useState(false);

  return (
    <div className="fixed inset-0 z-40 flex items-start justify-center overflow-y-auto overscroll-contain bg-slate-900/50 p-4" onClick={aoFechar}>
      <div className="my-auto w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <Cartao>
          <h3 className="text-lg font-semibold text-tinta-900">Novo evento</h3>
          {erro && (
            <div className="mt-3">
              <Alerta>{erro}</Alerta>
            </div>
          )}
          <div className="mt-4 space-y-3">
            <label className="block">
              <span className="mb-1 block text-sm font-medium text-tinta-700">Título</span>
              <input
                autoFocus
                value={titulo}
                onChange={(e) => setTitulo(e.target.value)}
                className="w-full rounded-xl border border-tinta-200 px-3 py-2"
              />
            </label>

            <div className="grid grid-cols-2 gap-3">
              <label className="block">
                <span className="mb-1 block text-sm font-medium text-tinta-700">Tipo</span>
                <select
                  value={tipo}
                  onChange={(e) => setTipo(e.target.value)}
                  className="w-full rounded-xl border border-tinta-200 bg-white px-3 py-2"
                >
                  <option value="culto">Culto</option>
                  <option value="ensaio">Ensaio</option>
                  <option value="especial">Evento especial</option>
                  <option value="reuniao">Reuniao</option>
                </select>
              </label>
              <label className="block">
                <span className="mb-1 block text-sm font-medium text-tinta-700">Quando</span>
                <input
                  type="datetime-local"
                  value={quando}
                  onChange={(e) => setQuando(e.target.value)}
                  className="w-full rounded-xl border border-tinta-200 px-3 py-2"
                />
              </label>
            </div>

            <label className="block">
              <span className="mb-1 block text-sm font-medium text-tinta-700">Local</span>
              <input
                value={local}
                onChange={(e) => setLocal(e.target.value)}
                className="w-full rounded-xl border border-tinta-200 px-3 py-2"
              />
            </label>

            <label className="block">
              <span className="mb-1 block text-sm font-medium text-tinta-700">Descrição</span>
              <textarea
                rows={3}
                value={descricao}
                onChange={(e) => setDescricao(e.target.value)}
                className="w-full rounded-xl border border-tinta-200 px-3 py-2 text-sm"
              />
            </label>

            <label className="flex items-center gap-2 text-sm text-tinta-700">
              <input type="checkbox" checked={publico} onChange={(e) => setPublico(e.target.checked)} />
              Visivel para os membros da igreja
            </label>
          </div>

          <div className="mt-5 flex justify-end gap-2">
            <Botao variante="secundario" onClick={aoFechar}>
              Cancelar
            </Botao>
            <Botao
              carregando={salvando}
              onClick={async () => {
                setErro(null);
                const inicio = doCampoDataHora(quando);
                if (!titulo.trim() || !inicio) {
                  setErro('Preencha o título e a data.');
                  return;
                }
                setSalvando(true);
                try {
                  await criarEvento({
                    titulo: titulo.trim(),
                    tipo,
                    local: local.trim() || null,
                    descricao: descricao.trim() || null,
                    inicioEm: inicio,
                    publico,
                  });
                  await aoCriar();
                } catch (e) {
                  setErro(e instanceof ErroApi ? e.message : 'Não consegui criar o evento.');
                } finally {
                  setSalvando(false);
                }
              }}
            >
              Criar evento
            </Botao>
          </div>
        </Cartao>
      </div>
    </div>
  );
}
